import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class OfficialAnnouncementsService extends BaseService {
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  get(data): Observable<any> {
    return this.getRequest(AppUrl.OFFICIAL_ANNOUNCEMENTS('GET'), data);
  }

  getLatestAnnouncement(data): Observable<any> {
    return this.getRequest(AppUrl.OFFICIAL_LATEST_ANNOUNCEMENTS(), data);
  }

  detail(data): Observable<any> {
    return this.postRequest(AppUrl.OFFICIAL_ANNOUNCEMENTS('DETAIL'), data);
  }
}
